import { useContext } from "react";
import FilterContext from "../../context/Filter/FilterContext";

const FilterData = () => useContext(FilterContext);

export default FilterData;
